import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Plus_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 2.75C10.4142 2.75 10.75 3.08579 10.75 3.5V9.25H16.5C16.9142 9.25 17.25 9.58579 17.25 10C17.25 10.4142 16.9142 10.75 16.5 10.75H10.75V16.5C10.75 16.9142 10.4142 17.25 10 17.25C9.58579 17.25 9.25 16.9142 9.25 16.5V10.75H3.5C3.08579 10.75 2.75 10.4142 2.75 10C2.75 9.58579 3.08579 9.25 3.5 9.25H9.25V3.5C9.25 3.08579 9.58579 2.75 10 2.75Z"
            />
        </SvgStyled>
    );
};

export default Plus_sm;
